module.exports = __webpack_public_path__ + "img/phone.5e6c4797.png";